import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { COLOR_CLASSES } from './ColorConfig';
import { CTA_VARIANTS } from './LandingPageConfig';
import { trackEvent } from '../../../utils/clarity';
var StickyCtaBar = function () {
    var _a = useState(false), isVisible = _a[0], setIsVisible = _a[1];
    var navigate = useNavigate();
    useEffect(function () {
        var handleScroll = function () {
            // Aparece depois de 15% da página
            var scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
            setIsVisible(scrollPercent > 15);
        };
        window.addEventListener('scroll', handleScroll);
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, []);
    var handleCtaClick = function () {
        trackEvent('landing_sticky_bar_cta_clicked'); // ✅ CTA sticky
        navigate('/register');
    };
    return (React.createElement("div", { className: "\n                fixed bottom-0 left-0 right-0 z-50 \n                transition-all duration-500 ease-out\n                ".concat(isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0', "\n            ") },
        React.createElement("div", { className: "bg-gray-900/95 backdrop-blur-lg border-t-2 border-yellow-500/50 shadow-2xl" },
            React.createElement("div", { className: "max-w-7xl mx-auto px-2 pt-1 pb-0 md:py-3 flex flex-col md:flex-row items-center justify-between gap-2 md:gap-4" },
                React.createElement("div", { className: "text-center md:text-left" },
                    React.createElement("p", { className: "text-white font-bold text-base md:text-lg leading-tight" }, "Ainda monitorando manualmente? \uD83D\uDD25"),
                    React.createElement("p", { className: "text-gray-400 text-xs md:text-sm leading-tight" }, "Comece seu teste gr\u00E1tis agora \u2014 sem cart\u00E3o")),
                React.createElement("button", { onClick: handleCtaClick, className: "\n                            ".concat(COLOR_CLASSES.ctaPrimary, "\n                            px-5 pt-1 pb-0 md:px-8 md:py-4 rounded-xl\n                            whitespace-nowrap\n                            shadow-lg\n                            text-base md:text-lg\n                        ") }, CTA_VARIANTS.hero)))));
};
export default StickyCtaBar;
